import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './equipeActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Button from '../../common/form/button';

class EquipeForm extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit} autoComplete="off" className="simple-cad-form-premium manutencao-cad-premium equipe-cad-premium">
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-user-friends" /> Equipe de Manutenção
              </h4>
              <p>Cadastre as equipes responsáveis pelas ordens de serviço em campo.</p>
            </div>
            <div className="simple-cad-premium-body">
              <Field name="id" component={LabelAndInput} readOnly label="Código" cols="12 4" placeholder="Automático" />
              <Field
                name="nome"
                component={LabelAndInput}
                label="Nome da equipe"
                cols="12 5"
                placeholder="Ex.: Equipe Alfa"
              />
              <Field name="ativo" component={LabelAndSelectForm} label="Situação" cols="12 3">
                <option value="1">Ativa</option>
                <option value="0">Inativa</option>
              </Field>
            </div>
          </div>
        </div>
        <div className="simple-cad-premium-footer">
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

EquipeForm = reduxForm({ form: 'equipeForm', destroyOnUnmount: false })(EquipeForm);
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(null, mapDispatchToProps)(EquipeForm);
